import React from "react";
import { FormattedMessage } from "react-intl";

import { BaseHeader } from "../../../components/layout/headerComponents/baseHeader/BaseHeader";
import { HeaderLogo } from "../../../components/layout/headerComponents/headerLogo/HeaderLogo";
import { Mobile, NotMobile } from "../../../common/Responsive";
import {
  HeaderTitle,
  HeaderTitleCompact,
} from "../../../components/layout/headerComponents/headerTitle/HeaderTitle";
import { HelpPageLink } from "../../../components/helpPageLink/HelpPageLink";

import "./LoginHeader.scss";

export const LoginHeader = () => (
  <BaseHeader className="login-header">
    <NotMobile>
      <div className="login-header__content-left">
        <HeaderLogo />
        <HeaderTitle />
      </div>
      <div className="login-header__content-right">
        <HelpPageLink className={"link--inverted"}>
          <FormattedMessage id={"help_and_documentation"} />
        </HelpPageLink>
      </div>
    </NotMobile>
    <Mobile>
      <div className="login-header__content-left">
        <HeaderTitleCompact />
      </div>
      <div className="login-header__content-right">
        <HelpPageLink className={"link--inverted"}>
          <FormattedMessage id={"help"} />
        </HelpPageLink>
      </div>
    </Mobile>
  </BaseHeader>
);
